export default {
	getDataLoading: (state) => state.dataLoading,
	getDataLoaded: (state) => state.dataLoaded,
	// getNotLoggedIn: (state) => state.notLoggedIn,
	getMainSidebarOpenState: (state) => state.mainSidebarOpenState,
	getSecondSidebarOpenState: (state) => state.secondSidebarOpenState,
	getAccountSubmenuOpenState: (state) => state.accountSubmenuOpenState,
	getEventSubmenuOpenState: (state) => state.eventSubmenuOpenState,
	getMerchandiseSubmenuOpenState: (state) => state.merchandiseSubmenuOpenState,
	getNotificationsState: (state) => state.notificationsState,
	getShowWelcomePopup: (state) => state.showWelcomePopup,
	getNotifications: (state) => state.notifications,
	getLoggedOut: (state) => state.loggedOut,
	getLogoutTime: (state) => state.logoutTime,
	getSearchTerm: (state) => state.searchTerm,
};
